import { DashboardWidgetType } from 'src/constants/dashboard';
import WidgetViewDoughnutWidget from 'src/components/survey/SurveySelectionPage/widgets/WidgetViewDoughnutWidget';
import WidgetViewNPSGaugeWidget from 'src/components/survey/SurveySelectionPage/widgets/WidgetViewNPSGaugeWidget';
import WidgetViewSpeedometerReWidget from 'src/components/survey/SurveySelectionPage/widgets/WidgetViewSpeedometerReWidget';
import WidgetViewSpeedometerWidget from 'src/components/survey/SurveySelectionPage/widgets/WidgetViewSpeedometerWidget';

export const getWidget = (widgetType?: number | null) => {
  if (typeof widgetType !== 'number') return null;

  // Add new widgets for the survey widget view here
  return (
    {
      [DashboardWidgetType.DOUGHNUT]: WidgetViewDoughnutWidget,
      [DashboardWidgetType.SPEEDOMETER]: WidgetViewSpeedometerWidget,
      [DashboardWidgetType.SPEEDOMETER_RE]: WidgetViewSpeedometerReWidget,
      [DashboardWidgetType.NPS_SCORE_GAUGE]: WidgetViewNPSGaugeWidget,
    }[widgetType] || null
  );
};
